import React, { Component, Suspense, Fragment } from "react";
import { connect } from "react-redux";
import { Router, Route, Switch, } from "react-router-dom";
import { NProgress, } from "../components";
import BaseLayout from "@/layouts/BaseLayout";
import { createBrowserHistory } from "history";
import { getSystemReleasePath } from "../core/system";
import { getRouter } from "../core/options";
import { lazyImportPath } from "../core/lazy";

let HISTTORY = createBrowserHistory();

class RouterViewImpl extends Component {

  wrapper = null;
  constantRoutes = [];

  constructor(props) {
    super(props);
    this.initConstantRoutes();
  }

  initConstantRoutes = () => {
    const { routes } = getRouter();
    this.constantRoutes = routes.map(item => ({
      path: getSystemReleasePath(item.path),
      component: lazyImportPath(item.component),
    }));
  };

  generateRoute = (routes, perItem) => {
    let Wrapper = this.wrapper;
    if (!this.wrapper) {
      Wrapper = this.wrapper = lazyImportPath(getRouter().wrapper);
    }
    return (
      <Fragment>
        {
          routes.map((item) => {
            const path = 0 === item.path.indexOf("/") ? item.path : `${perItem.path}/${item.path}`;
            return (
              <Fragment key={path}>
                <Route exact={item.exact || false} path={path} component={
                  (props) => (
                    <Wrapper {...props}>
                      <item.component />
                    </Wrapper>
                  )
                } />
                {item.children && item.children.length ? this.generateRoute(item.children, item) : <Fragment />}
              </Fragment>
            )
          })
        }
      </Fragment>
    );
  };

  render() {
    return (
      <Suspense fallback={<NProgress />}>
        <Router history={HISTTORY}>
          <Switch>
            {
              this.constantRoutes.map(item => {
                return <Route key={item.path} exact={item.exact} path={item.path} component={item.component} />
              })
            }
            {
              this.props.menuList.length && (
                <BaseLayout>
                  <Suspense fallback={<NProgress />}>
                    <Switch>
                      {this.generateRoute(this.props.menuList)}
                    </Switch>
                  </Suspense>
                </BaseLayout>
              )
            }
          </Switch>
        </Router>
      </Suspense>
    );
  };
}

export const RouterView = connect((state) => {
  return {
    menuList: state.resource.menuList
  };
})(RouterViewImpl);

function Histtory() {

  this.go = (num) => {
    return HISTTORY.go(num);
  };

  this.goBack = () => {
    return HISTTORY.goBack();
  };

  this.goForward = () => {
    return HISTTORY.goForward();
  };

  this.listen = (listener) => {
    return HISTTORY.listen(listener);
  };

  this.location = () => {
    return HISTTORY.location;
  };

  this.push = (path, state) => {
    path = getSystemReleasePath(path);
    return HISTTORY.push(path, state);
  };

  this.replace = (path, state) => {
    path = getSystemReleasePath(path);
    return HISTTORY.replace(path, state);
  };

}

export const history = new Histtory();
